// extracted by mini-css-extract-plugin
export default {"BreadcrumbContainer":"ContentManager_BreadcrumbContainer__eTa0F"};